import { render, staticRenderFns } from "./TopicVoteWay.vue?vue&type=template&id=20067c01&scoped=true"
import script from "./TopicVoteWay.vue?vue&type=script&lang=js"
export * from "./TopicVoteWay.vue?vue&type=script&lang=js"
import style0 from "./TopicVoteWay.vue?vue&type=style&index=0&id=20067c01&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20067c01",
  null
  
)

export default component.exports